export default {
  countries: [
    { countryCode: 'NL' },
    { countryCode: 'GB' },
    { countryCode: 'BE' },
    { countryCode: 'FR' },
    { countryCode: 'PL' },
    { countryCode: 'UA' },
    { countryCode: 'ES' },
    { countryCode: 'JO' },
    { countryCode: 'HU' },
    { countryCode: 'NG' },
    { countryCode: 'FI' },
    { countryCode: 'CN' },
    { countryCode: 'JM' },
    { countryCode: 'TZ' },
    { countryCode: 'KE' },
    { countryCode: 'UG' },
    { countryCode: 'DE' },
    { countryCode: 'DA' },
  ],
};
